(function () {
  'use strict';
  const script = document.currentScript;
  const configNode = script?.previousElementSibling;
  if (!configNode?.matches('[data-printlabs-cart-config]')) return;
  const config = JSON.parse(configNode.textContent);
  const params = new URLSearchParams(location.search);
  const pick = (keys) => keys.map(key => params.get(key)).find(Boolean) || '';
  const designId = pick(['design_id', 'designId', 'design', 'design_code', 'designCode', 'customization_id', 'customizationId', 'printlabs_design_id']);
  if (!designId) return;
  const quantity = Number(pick(['quantity', 'qty', 'total_quantity', 'totalQty', 'units', 'uds']));
  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  configNode.before(status);
  const fail = error => { status.textContent = error.message || 'No se pudo actualizar el carrito. Vuelve a intentarlo.'; };
  if (!Number.isSafeInteger(quantity) || quantity < 1) {
    fail(new Error('La cantidad del diseño no es válida. Revisa las unidades en el personalizador.'));
    return;
  }
  const variantId = pick(['variant_id', 'variantId', 'variant', 'id']) || String(config.defaultVariant);
  const selected = config.variants.find(variant => String(variant.id) === variantId);
  if (!selected) { fail(new Error('No se encontró la variante del producto.')); return; }
  const quantityIndex = config.options.findIndex(name => /^(cantidad|unidades|quantity)$/i.test(name.trim()));
  const tierRange = value => {
    const match = String(value).trim().match(/^(\d+)\s*(?:(?:[-–]\s*(\d+))|(\+))?\s*(?:uds?\.?|unidades|units?)?$/i);
    return match ? { min: Number(match[1]), max: match[3] ? Infinity : Number(match[2] || match[1]) } : null;
  };
  const variant = quantityIndex < 0 ? selected : config.variants.find(candidate => {
    const range = tierRange(candidate.options[quantityIndex]);
    return range && quantity >= range.min && quantity <= range.max && candidate.options.every((option, index) => index === quantityIndex || option === selected.options[index]);
  });
  if (!variant || !variant.available) { fail(new Error('No hay una variante disponible para esa cantidad. Revisa las unidades del diseño.')); return; }
  const runKey = config.productId + ':' + designId;
  window.printlabsCartTransfers = window.printlabsCartTransfers || new Set();
  if (window.printlabsCartTransfers.has(runKey)) { status.remove(); return; }
  window.printlabsCartTransfers.add(runKey);
  const root = window.Shopify?.routes?.root || '/';
  const request = async (path, body) => {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'No se pudo actualizar el carrito.');
    return result;
  };
  const transfer = async () => {
    status.textContent = 'Actualizando tu diseño en el carrito…';
    const cart = await request('cart.js');
    const matchesDesign = item => String(item.product_id) === String(config.productId) && (item.properties?._printlabs_design_id === designId || item.properties?.['Diseño'] === designId);
    const previous = cart.items.filter(matchesDesign);
    const matching = previous.find(item => String(item.variant_id) === String(variant.id));
    const reopen = new URL(config.editorUrl);
    reopen.searchParams.set('design_id', designId);
    reopen.searchParams.set('variant_id', String(variant.id));
    reopen.searchParams.set('quantity', String(quantity));
    const properties = {
      ...(matching?.properties || previous[0]?.properties || {}),
      'Diseño': designId,
      'Enlace al diseño': reopen.toString(),
      '_printlabs_design_id': designId
    };
    const labels = { customization_size: 'Talla', customization_color: 'Color', customization_breakdown: 'Desglose' };
    Object.keys(labels).forEach(key => {
      const value = params.get(key);
      if (value) properties['Personalización - ' + key] = value;
    });
    // These are informational. Shopify's actual variant price determines checkout.
    properties['_printlabs_unit_price'] = (variant.price / 100).toFixed(2);
    properties['_printlabs_total_price'] = (variant.price * quantity / 100).toFixed(2);
    const preview = pick(['design_preview_url', 'preview_url']);
    if (/^https:\/\//i.test(preview) && preview.length < 2000) properties._Preview = preview;
    if (matching) {
      await request('cart/change.js', { id: matching.key, quantity, properties });
    } else {
      await request('cart/add.js', { items: [{ id: variant.id, quantity, properties }] });
    }
    // Add the new tier before removing the old one, so a failed add preserves the design.
    const obsolete = previous.filter(item => item.key !== matching?.key);
    if (obsolete.length) {
      await request('cart/update.js', { updates: Object.fromEntries(obsolete.map(item => [item.key, 0])) });
    }
    const verified = await request('cart.js');
    const lines = verified.items.filter(matchesDesign);
    if (lines.length !== 1 || lines[0].quantity !== quantity || String(lines[0].variant_id) !== String(variant.id)) {
      throw new Error('No se pudo confirmar la cantidad del diseño. Revisa el carrito antes de continuar.');
    }
    location.assign(root + 'cart');
  };
  transfer().catch(error => { window.printlabsCartTransfers.delete(runKey); fail(error); });
})();
